module.exports = __webpack_public_path__ + "static/media/客服 (3).06691ce0.svg";